import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        forms: '=',
        courses: '=',
        sites: '='
    },
    template: `
    <div class="modal-header">
        <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
        <h2>{{ 'forms.Export data dump' | translate }}</h2>
    </div>
    <div class="modal-body">
        <form class="form">
            <alert-error ng-if="vm.errors.formIds">{{ vm.errors.formIds }}</alert-error>
            <alert-error ng-if="vm.errors.courseIds">{{ vm.errors.courseIds }}</alert-error>
            <form-row error="vm.errors.formIds">
                <label class="label">{{ 'forms.Form' | translate }}</label>
                <div class="items">
                    <div
                        ng-dropdown-multiselect=""
                        options="vm.multiFilter.forms.options"
                        selected-model="vm.multiFilter.forms.model"
                        events="vm.multiFilter.forms.events"
                        extra-settings="vm.multiFilter.settings"
                        ng-click="vm.updateCourses()"
                        translation-texts="vm.multiFilter.translations"
                        >
                    </div>
                </div>
            </form-row>
            <form-row error="vm.errors.formIds">
                <label class="label">{{ 'forms.Course' | translate }}</label>
                <div class="items">
                    <div
                        ng-if="vm.toggleCourse"
                        ng-dropdown-multiselect=""
                        options="vm.multiFilter.courses.options"
                        selected-model="vm.multiFilter.courses.model"
                        extra-settings="vm.multiFilter.settings"
                        translation-texts="vm.multiFilter.translations"
                    ></div>
                    <div
                        ng-if="!vm.toggleCourse"
                        ng-dropdown-multiselect=""
                        options="vm.multiFilter.courses.options"
                        selected-model="vm.multiFilter.courses.model"
                        extra-settings="vm.multiFilter.settings"
                        translation-texts="vm.multiFilter.translations"
                    ></div>
                </div>
            </form-row>
            <div class="row">
                <label class="label">{{ 'forms.Site' | translate }}</label>
                <div class="items">
                    <div
                        ng-dropdown-multiselect=""
                        options="vm.multiFilter.sites.options"
                        selected-model="vm.multiFilter.sites.model"
                        extra-settings="vm.multiFilter.settings"
                        translation-texts="vm.multiFilter.translations"
                        >
                    </div>
                </div>
            </div>
            <form-row class="row" error="vm.errors.from">
                <span class="label">{{ 'forms.From' | translate }}</span>
                <div class="items">
                    <datepicker-api ng-model="vm.filter.from"></datepicker-api>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row class="row" error="vm.errors.to">
                <span class="label">{{ 'forms.To' | translate }}</span>
                <div class="items">
                    <datepicker-api ng-model="vm.filter.to"></datepicker-api>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </form>
    </div>
    <div class="modal-footer">
        <ul class="actions01">
            <li class="primary">
                <button class="btn main" type="button" ng-click="vm.export()">{{ 'forms.Export data dump' | translate }}</button>
            </li>
            <li class="primary">
                <button class="btn bordered02" type="button" ng-click="vm.reset()">{{ 'general.Reset' | translate }}</button>
            </li>
            <li>
                <button
                    class="btn discrete"
                    type="button"
                    ng-click="vm.uibModalInstance.dismiss()"
                >{{ 'general.Cancel' | translate }}</button>
            </li>
        </ul>
    </div>
    `
})
export default class {
    constructor ($q, $window, $httpParamSerializer, $translate, lodash, moment, AuthResource, QuestionResource,
                 ResponseService) {
        this.$q = $q;
        this.$window = $window;
        this.$httpParamSerializer = $httpParamSerializer;
        this.$translate = $translate;
        this.lodash = lodash;
        this.moment = moment;
        this.AuthResource = AuthResource;
        this.QuestionResource = QuestionResource;
        this.ResponseService = ResponseService;
    }

    $onInit () {
        this.filter = {
            to: this.moment().format('YYYY-MM-DD'),
            _lang: this.$translate.use()
        };
        this.defaultFilter = angular.copy(this.filter);
        this.initMultiFilter();
    }

    initMultiFilter () {
        const formOptions = this.forms.map(form => {
            return {
                value: form.id,
                label: form.activeI18n.name
            };
        });
        const courseOptions = this.courses.map(course => {
            return {
                value: course.id,
                label: course.activeI18n.name
            };
        });
        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        this.multiFilter = {
            forms: {
                model: [],
                options: formOptions,
                events: {
                    onSelectionChanged: () => {
                        const selectedFormIds = this.multiFilter.forms.model.map(item => item.value);
                        let validCourses = this.courses;
                        if (selectedFormIds.length) {
                            validCourses = this.courses.filter(course => {
                                let courseFormIds = course.testTrainings.map(item => item.formId);
                                courseFormIds = courseFormIds.concat(course.testTrainings.map(item => item.feedbackFormId));
                                courseFormIds = courseFormIds.concat(course.courseTrainingForms.map(item => item.formId));
                                courseFormIds = courseFormIds.filter(Boolean);
                                return this.lodash.some(courseFormIds, item => this.lodash.includes(selectedFormIds, item));
                            });
                        }
                        this.multiFilter.courses.options = validCourses.map(course => {
                            return {
                                value: course.id,
                                label: course.activeI18n.name
                            };
                        });
                        this.multiFilter.courses.model = this.multiFilter.courses.options.filter(course => {
                            return this.lodash.some(this.multiFilter.courses.model, item => item.value === course.value);
                        });
                        this.toggleCourse = !this.toggleCourse;
                    }
                }
            },
            courses: {
                model: [],
                options: courseOptions
            },
            sites: {
                model: [],
                options: siteOptions
            },
            settings: {
                enableSearch: true,
                checkBoxes: true,
                showCheckAll: false,
                showUncheckAll: false,
                smartButtonMaxItems: 3,
                smartButtonTextConverter: itemText => itemText
            },
            translations: {
                buttonDefaultText: this.$translate.instant('filter.Select'),
                searchPlaceholder: this.$translate.instant('general.Search')
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    export () {
        const { multiFilter } = this;
        const cb = i => i.value;

        const filter = angular.copy(this.filter);
        if (multiFilter.forms.model.length) {
            filter['formIds[]'] = multiFilter.forms.model.map(cb);
        }

        if (multiFilter.courses.model.length) {
            filter['courseIds[]'] = multiFilter.courses.model.map(cb);
        }

        if (multiFilter.sites.model.length) {
            filter['siteIds[]'] = multiFilter.sites.model.map(cb);
        }

        this.errors = {};
        const validationParams = this.lodash.assign({ validateOnly: true }, filter);
        this.QuestionResource.dataDumpValidation(validationParams).$promise
            .then(() => {
                this.AuthResource.requestTacToken().$promise.then(({ token }) => {
                    filter.tacToken = token;
                    const url = `${SEED_CORE.ENV.API_URL}form/question/data-dump-export/?${this.$httpParamSerializer(filter)}`;
                    this.$window.open(url);
                });
            }).catch(response => {
                this.errors = this.ResponseService.parseErrors(response);
            });
    }

    reset () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/forms/export/index.js